import axios from 'axios';
import config from './config'
import { util, lg } from 'utils';

let base = util.getDomain();

//登录退出
export const requestLogin = params => { return axios.get(`${base}/api/Admin/Login`, { params: params }); };
export const requestLogout = params => { return axios.get(`${base}/api/Admin/Logout`, { params: params }); };
//获取通用配置信息
export const GetParmConfig = params => { return axios.get(`${base}/api/Common/GetParmConfig`, { params: params }); };
//产品分类（成品，半成品）
export const GetProductClass = params => { return axios.get(`${base}/api/Common/GetProductClass`, { params: params }); };
/*添加商品信息*/
export const ParmConfigAdd = params => { return axios.post(`${base}/api/ParmConfig/ERP_ParmConfigAdd`, params, config); };
/*删除商品信息*/

export const ParmConfigDel = params => { return axios.post(`${base}/api/ParmConfig/ERP_ParmConfigDel`, params, config); };

//员工列表查询
export const GetEmployList = params => { return axios.get(`${base}/api/Common/GetEmployList`, { params: params }); };

/*产品属性*/

export const GetProductAttribute = params => { return axios.get(`${base}/api/Common/GetProductAttribute`, { params: params }); };
//获取省市区
export const GetProvinces = params => { return axios.get(`${base}/api/Common/GetProvinces`, { params: params }); };
export const GetCitys = params => { return axios.get(`${base}/api/Common/GetCitys`, { params: params }); };
export const GetAreas = params => { return axios.get(`${base}/api/Common/GetAreas`, { params: params }); };
//代理商列表
export const GetAgentList = params => { return axios.get(`${base}/api/Common/GetAgentList`, { params: params }); }
//获得代理商列表POST /api/Common/CRM_Agent_Consignee_Add
export const GetAgentConsigneeList = params => { return axios.get(`${base}/api/Common/GetAgentConsigneeList`, { params: params }); }
//新增收货地址GET /api/Common/CRM_Agent_ConsigneeSetDefault
export const Consignee_Add = params => { return axios.post(`${base}/api/Common/CRM_Agent_Consignee_Add`, params, config); };
//设置当前默认地址
export const ConsigneeSetDefault = params => { return axios.get(`${base}/api/Common/CRM_Agent_ConsigneeSetDefault`, { params: params }); }




// WEBPACK FOOTER //
// ./src/api/commonApi.js